<template>
  <div></div>
</template>

<script>
export default {
  name: 'Heading3AfterHeading2',
  props: {
    regulationItem: {
      type: Object,
      required: true
    }
  }
}
</script>
